import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";

import { getInfectedDevicesForTable } from "../../../../store/devices/devices.selectors";
import { Table } from "../../../../components/table/Table";
import { InfectionsList } from "../../../../components/infectionsList/InfectionsList";
import { NotMobile, Mobile } from "../../../../hocs/Responsive";
import { useIntlTranslate } from "../../../../hooks";
import {
  COLUMNS,
  COLUMNS_MOBILE,
  SUB_HEADER,
  INITIAL_SORT,
  SEARCH_KEYS,
} from "./InfectedDevicesTable.consts";
import { InfectedDevicesTableHeader } from "./components";

export const InfectedDevicesTable = () => {
  const devices = useSelector(getInfectedDevicesForTable, _.isEqual);
  const translate = useIntlTranslate();
  const caption = translate("showing_data_for_the_past_24");

  return (
    <Fragment>
      <Mobile>
        <Table
          header={<InfectedDevicesTableHeader />}
          searchKeys={SEARCH_KEYS}
          showPagination
          visibleHeader={false}
          data={devices}
          columns={COLUMNS_MOBILE}
          hiddenColumns={["id", "flatInfections"]}
          renderRowSubComponent={renderRowSubComponent}
          defaultSorted={INITIAL_SORT}
          subHeader={SUB_HEADER}
          searchAriaLabelMessage="aria_search_for_device"
          caption={caption}
        />
      </Mobile>
      <NotMobile>
        <Table
          header={<InfectedDevicesTableHeader />}
          searchKeys={SEARCH_KEYS}
          showPagination
          columns={COLUMNS}
          data={devices}
          subHeader={SUB_HEADER}
          defaultSorted={INITIAL_SORT}
          searchAriaLabelMessage="aria_search_for_device"
          caption={caption}
        />
      </NotMobile>
    </Fragment>
  );
};

const renderRowSubComponent = ({
  row: {
    original: { infections },
  },
}) => {
  return (
    <div className={"sub-row-content"} data-testid="infected-device-sub-row">
      <InfectionsList infections={infections} />
    </div>
  );
};
